// Canonical API origin for the SPA.
// Dev: empty VITE_API_URL → current origin (Vite proxies /rpc + /api same-origin).
// Prod: VITE_API_URL points at the API origin (same-site subdomain, credentialed CORS).
export const API_BASE =
  import.meta.env.VITE_API_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173');
